import { jsx } from "react/jsx-runtime";
import { memo } from "react";
import { CarTile } from "@perxis-auto/ui-kit/lib/components/CarTile";
import { useCreditDataTile } from "../../../features/credit/lib/useCreditDataTile.js";
import { withEnabledComponent } from "../../../shared/lib/constructor/withEnabledComponent.js";
import "../../../shared/store/config/middleware/index.js";
import "../../../shared/store/config/model/selectors/selectBenefits.js";
import "../../../shared/store/config/model/selectors/selectBooking.js";
import { selectCredit } from "../../../shared/store/config/model/selectors/selectCredit.js";
import "../../../shared/store/config/model/selectors/selectFilterGrid.js";
import "../../../shared/store/config/model/selectors/selectFilterGridItems.js";
import "../../../shared/store/config/model/selectors/selectFilters.js";
import "../../../shared/store/config/model/selectors/selectGeolocator.js";
import "../../../shared/store/config/model/selectors/selectLocationCollectionIds.js";
import "../../../shared/store/config/model/selectors/selectMaps.js";
import "../../../shared/store/config/model/selectors/selectModels.js";
import "../../../shared/store/config/model/selectors/selectSort.js";
import "../../../shared/store/config/model/selectors/selectTags.js";
import "../../../shared/store/config/model/selectors/selectTradeIn.js";
import "../../../shared/store/config/model/slice.js";
const TilePayment = withEnabledComponent(
  memo(function TilePayment2({ credit, isLoading = false, ...props }) {
    useCreditDataTile(credit);
    if (isLoading) {
      return /* @__PURE__ */ jsx(CarTile.PaymentSkeleton, {});
    }
    return /* @__PURE__ */ jsx(CarTile.Payment, { ...props });
  }),
  selectCredit
);
export {
  TilePayment
};
